import { Directive, Input, Output, EventEmitter, HostListener } from "@angular/core";

 
@Directive({
    selector: '[canvasCopyClipboard]',
    standalone: false
})
export class CopyClipboardDirective {

  @Input("canvasCopyClipboard")
  public payload!: string;

  @Output()
  public copied: EventEmitter<string> = new EventEmitter<string>();

  @HostListener("click", ["$event"])
  public async onClick(event: MouseEvent): Promise<void> {
    event.preventDefault();
    if (!this.payload) return;

    try {
      await navigator.clipboard.writeText(this.payload);
      this.copied.emit(this.payload);
    } catch (error) {
      console.error("Copy failed", error);
    }
  }
}
